import { BellRing, GitFork, Link, RefreshCcw } from "lucide-react";
import { BenefitItem } from "../AIReelGenration/components/benefit-item";

export default function AIBasedStudent() {
    return (
        <main className="mt-14 py-4">
            <div className="max-w-7xl mx-auto px-12 sm:px-4">
                {/* Header Section */}
                <header className="text-center">
                    <h1 className="text-balance text-5xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]">
                        AI-Based Student Communication System
                    </h1>
                    <p className="mx-auto max-w-3xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium">
                        Streamline all school-to-parent communication with our AI-powered Student Communication System. Keep parents informed and engaged through WhatsApp, IVR, and the mobile app, while connecting seamlessly via the school app.
                    </p>
                </header>
                {/* Main Content Section */}
                <div className="mt-8 md:mt-12 sm:mt-8 grid grid-cols-2 md:grid-cols-1 gap-8 md:gap-6 sm:gap-4 items-start mb-12 md:mb-8 sm:mb-6">
                    {/* Left Side */}
                    <aside aria-label="Key features" className="self-center space-y-6 md:space-y-5 sm:space-y-4">
                        <section className="border-b border-gray-300">
                            <div className="flex flex-col justify-start gap-1 mb-3">
                                <div className="p-2 bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] w-fit rounded-full border border-gray-300">
                                    <RefreshCcw className="text-blue-600"/>
                                </div>
                                <div>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground font-medium">Automated updates on attendance, homework, examination dates, and results.</p>
                                </div>
                            </div>
                        </section>

                        <section className="border-b border-gray-300">
                            <div className="flex flex-col justify-start gap-1 mb-3">
                                <div className="p-2 bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] w-fit rounded-full border border-gray-300">
                                    <BellRing className="text-blue-600"/>
                                </div>
                                <div>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground font-medium">Notifications for fee dues, parent-teacher meetings, birthday wishes, festival greetings, and general announcements.</p>
                                </div>
                            </div>
                        </section>

                        <section className="border-b border-gray-300">
                            <div className="flex flex-col justify-start gap-1 mb-3">
                                <div className="p-2 bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] w-fit rounded-full border border-gray-300">
                                    <GitFork className="text-blue-600"/>
                                </div>
                                <div>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground font-medium">Multi-channel delivery through WhatsApp, calls, and mobile apps—ensuring timely and effective communication.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="flex flex-col justify-start gap-1">
                                 <div className="p-2 bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] w-fit rounded-full border border-gray-300">
                                    <Link className="text-blue-600"/>
                                </div>
                                <div>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground font-medium">Integrates school app to parent app for a smooth, direct connection.</p>
                                </div>
                            </div>
                        </section>
                    </aside>
                    {/* Right Side - Benefits */}
                    <div className="flex justify-end md:justify-center">
                        <img
                            src="/images/new-landing-page/aiBasedStudent.svg"
                            alt="aiBasedStudent"
                            className="w-[80%]"
                        />
                    </div>
                </div>
            </div>
             <section className="mt-14 md:mt-10 sm:mt-8">
                    <h2 className="text-center text-2xl font-semibold md:text-xl sm:text-lg">
                      Benefits for Schools
                    </h2>
                    <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-4 sm:gap-3">
                      <BenefitItem>Keeps parents informed in real-time, improving engagement and satisfaction.</BenefitItem>
                      <BenefitItem>Strengthens school-parent relationships, building trust and transparency.</BenefitItem>
                    </div>
                    <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-3 sm:gap-3">
                      <BenefitItem>Ensures important announcements are never missed.</BenefitItem>
                      <BenefitItem>Reduces manual follow-ups and administrative effort.</BenefitItem>
                    </div>
                  </section>
        </main>
    );
}